import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from '../hooks/use-toast';
import SEO from '../lib/SEO';

export default function News() {
  const [email, setEmail] = useState('');
  const subscribe = (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) return toast({ title: 'Please enter a valid email.' });
    toast({ title: 'Subscribed', description: 'We’ll email you when new updates are published.' });
    setEmail('');
  };
  return (
    <div className="font-sans-body">
      <SEO title="News & Updates | Apex Quality Control" description="Insights, updates and case notes from the field." />
      <section className="bg-aqc-cream">
        <div className="container-aqc py-16 lg:py-20">
          <span className="eyebrow">Latest</span>
          <h1 className="mt-4 font-serif text-[2.4rem] sm:text-[3rem] font-semibold text-aqc-navy">News &amp; Updates.</h1>
          <p className="mt-4 text-aqc-muted max-w-2xl">Insights, updates and case notes from the field.</p>
        </div>
      </section>

      <section className="py-16">
        <div className="container-aqc max-w-2xl text-center">
          <div className="bg-white border border-aqc-line rounded-2xl p-10 shadow-sm">
            <h2 className="font-serif text-2xl text-aqc-navy">No updates yet.</h2>
            <p className="mt-3 text-aqc-muted">
              Insights and case notes will appear here — check back soon or subscribe below.
            </p>
            <form onSubmit={subscribe} className="mt-6 flex flex-col sm:flex-row gap-2 max-w-md mx-auto">
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
                required
              />
              <Button type="submit" className="bg-aqc-navy hover:bg-[hsl(var(--aqc-navy-2))] text-white">
                Subscribe
              </Button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}
